
import { Button } from "@/components/ui/button";
import { ArrowLeft } from 'lucide-react'
import { useNavigate } from "react-router-dom";

const BackButton = ({ onClick, label = "Back to Deals", className = "", startIcon = false,prevLocation, ...props }) => {
  const navigation = useNavigate();
  
    const handleClick = () => {
    if (prevLocation) {
      navigation(prevLocation);
    } else if (onClick) {
      onClick();
    }
  };

  return (
    <Button
      type="button"
      onClick={handleClick}
      className={`inline-flex items-center gap-2  border border-card-border 
        bg-primary-foreground text-slate-900 font-medium text-sm 
        px-3.5 py-2 shadow-none 
        hover:bg-button-hover transition-colors duration-200 
        font-sans min-w-fit ${className}`}
      {...props}
    >
      {!startIcon  ? (
          <ArrowLeft className="w-4 h-4 mr-2 text-muted-foreground"/>
          ) : (
            startIcon
          )}
      <span className='text-muted-foreground'>{label}</span>
    </Button>
  );
};

export default BackButton;
